import init from './init.js'

// In a web page context, initialize based on DOM elements.
if (typeof document !== 'undefined') {
  if (['complete', 'interactive'].includes(document.readyState)) {
    init(document)
  } else {
    document.addEventListener('DOMContentLoaded', () => init(document))
  }
}

export { default as CounterWidget } from './counter.js'
export { default as Poller } from './poller.js'
export { default as Widget } from './widget.js'
